<template>
    <div class="container">

        <b-overlay :show="preLoading" rounded='pill' opacity="0.6" spinner-type="grow">
            <div class="card card-signin my-5">
                <div class="card-body">
                    <section class="text-center">
                        <img src="../../assets/wispot_colorido.svg" alt="Wispot Logo" class="logo" />
                    </section>
                    <hr class="my-4">
                    <div class="text-left box-instructions-data" v-if="showInstructions">
                        <h5>Instruções para exclusão de dados</h5>
                        <ol>
                            <li>Faça o Login</li>
                            <li>Veja os lugares que o wispot te ajudou a se conectar</li>
                            <li>Revogue seus dados compartilhados com uma localidade especifica</li>
                            <ul>
                                <li>Menu de opções no card da localidade</li>
                                <li>Informações compatilhadas</li>
                            </ul>
                            <li>Revogue seus dados compartilhados com o WISPOT</li>
                            <ul>
                                <li>Menu de opções da sua conta no canto superior direito</li>
                                <li>Perfil</li>
                            </ul>
                            <li>Escolha os dados que deseja revogar ou revogue tudo</li>
                            <li>Salvar</li>
                        </ol>
                        <hr class="my-4">
                    </div>
                    <div v-if="!waitingCode">
                        <div v-if="!verified">
                            <div class="form-group wi-input-icon" v-if="!cell">
                                <font-awesome-icon icon="user" class="icon" />
                                <b-form-input type="email" placeholder="Entre com seu e-mail"
                                    v-model.lazy="$v.email.$model" @keyup.enter="verifyEmailEnter"></b-form-input>
                                <div class="errors" v-if="$v.email.$error">
                                    <div class="error" v-if="!$v.email.email">E-mail invalido.</div>
                                    <div class="error" v-if="!$v.email.required">Insira um e-mail.</div>
                                </div>
                            </div>
                            <div class="form-group wi-input-icon" v-else>
                                <vue-tel-input v-model="phone" v-bind:dynamicPlaceholder="true"></vue-tel-input>
                            </div>

                            <b-button block variant="primary" @click="verifyEmail">continuar</b-button>
                            <div class="text-center">
                                <div class="forgot-pass" @click="forgotPass">Esqueci a senha</div>
                            </div>

                        </div>
                        <div v-else>
                            <div v-if="!hasPassword">
                                <div class="form-group wi-input-icon">
                                    <font-awesome-icon icon="unlock-alt" class="icon" />
                                    <b-form-input type="password" placeholder="digite uma senha"
                                        v-model.trim="$v.password.$model"></b-form-input>
                                </div>
                                <div class="form-group wi-input-icon">
                                    <font-awesome-icon icon="unlock-alt" class="icon" />
                                    <b-form-input type="password" placeholder="confirme a senha"
                                        v-model.trim="$v.repeatPassword.$model"></b-form-input>

                                    <div class="errors" v-if="$v.password.$error || $v.repeatPassword.$error">
                                        <div class="error" v-if="!$v.password.required">senha é requerida</div>
                                        <div class="error" v-if="!$v.password.minLength">a senha deve ter ao menos {{
                                            $v.password.$params.minLength.min }} characteres.</div>
                                        <div class="error" v-if="!$v.repeatPassword.sameAsPassword">As senhas não
                                            conferem.</div>
                                    </div>
                                </div>
                                <b-button block variant="primary" @click="createPassword">continuar</b-button>
                            </div>
                            <div v-else>
                                <div v-if="hasPassword && repeatPassword == ''">
                                    <div class="form-group wi-input-icon">
                                        <font-awesome-icon icon="unlock-alt" class="icon" />
                                        <b-form-input type="password" placeholder="digite sua senha"
                                            v-model.trim="$v.password.$model"></b-form-input>

                                        <div class="errors" v-if="$v.password.$error">
                                            <div class="error" v-if="!$v.password.required">senha é requerida</div>
                                            <div class="error" v-if="!$v.password.minLength">a senha deve ter ao menos
                                                {{ $v.password.$params.minLength.min }} characteres.</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <b-alert show variant="success">Sua senha foi cadastrada com sucesso!</b-alert>
                                </div>
                                <b-button block variant="primary" @click="login">Entrar</b-button>

                                <div class="text-center" v-if="hasPassword && repeatPassword == ''">
                                    <div class="forgot-pass" @click="forgotPass">Esqueci a senha</div>
                                </div>
                            </div>
                        </div>
                        <div class="login-plataforms" v-if="!verified">
                            <br>
                            <div class="separator">ou</div>
                            <br>
                            <b-button class="face-button p-0 text-left" @click="fblogin"><img class="face-img"
                                    src="../../assets/images/face-icon.png" alt="Facebook">ENTRAR COM
                                FACEBOOK</b-button>
                            <b-button class="google-button p-0 mt-2 text-left" @click="glogin"><img class="google-img"
                                    src="../../assets/images/google-icon.png" alt="Google">ENTRAR COM GOOGLE</b-button>
                            <b-button class="x-button p-0 mt-2 text-left" @click="xlogin"><img class="x-img"
                                    src="../../assets/images/x-login.png" alt="x">ENTRAR COM X</b-button>
                        </div>
                    </div>
                    <div v-if="waitingCode" class="text-center">
                        <p v-if="!waitingResetCode">Para seguir em frente é necessario confirmar seu email, te enviamos
                            um codigo.</p>
                        <p v-if="waitingResetCode">Para alterar sua senha é necessario confirmar o codigo, que enviamos
                            ao seu email.</p>
                        <b-form-input type="text" placeholder="xxxx" maxlength='4' class="wi-input-code"
                            v-model.lazy="$v.code.$model"></b-form-input>
                        <b-button v-if="!waitingResetCode" variant="outline-primary"
                            @click="confirmEmail">validar</b-button>
                        <b-button v-if="waitingResetCode" variant="outline-primary"
                            @click="resetPass">validar</b-button>
                        <div class="errors" v-if="$v.code.$error">
                            <div class="error" v-if="!$v.code.required">Insira o codigo enviado /p seu e-mail.</div>
                            <div class="error" v-if="!$v.code.minLength">Codigo possui 4 digitos.</div>
                        </div>
                    </div>
                    <b-alert dismissible show variant="danger" v-if="codeError" class="wi-alert"><a href="#"
                            class="alert-link">Codigo invalido</a></b-alert>

                    <p class="text-center mt-5 mb-3 text-muted">Powered Wispot</p>
                </div>
            </div>
        </b-overlay>

    </div>
</template>
<style scoped>
.box-instructions-data ol {
    padding-left: .8em;

}

.container {
    max-width: 400px;
    min-width: 400px;
}

.logo {
    display: inline-block;
    width: 200px;
}

.card-signin {
    border: 0;
    border-radius: 1rem;
    box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
}

.card-signin .card-title {
    margin-bottom: 2rem;
    font-weight: 300;
    font-size: 1.5rem;
}

.card-signin .card-body {
    padding: 2rem;
}

.form-signin {
    width: 100%;
}


.form-group.wi-input-icon {
    position: relative;
}

.form-group.wi-input-icon input {
    padding-left: 2.375rem;
}

.form-group.wi-input-icon .icon {
    position: absolute;
    z-index: 2;
    display: block;
    color: #aaa;
    top: 10px;
    left: 10px
}

.wi-input-code {
    width: 110px;
    letter-spacing: 11px;
    display: inline-block;
    margin: 0 1em;
}

.wi-alert {
    margin-top: 2em;
}

.error {
    margin-top: 4px;
}

.auth {
    text-align: center;
    font-size: 16px;
    font-weight: 550;
    color: #0062cc;
    cursor: pointer;
    margin: 10px;
}

.separator {
    display: flex;
    align-items: center;
    text-align: center;
}

.separator::before,
.separator::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #bbb;
}

.separator::before {
    margin-right: .25em;
}

.separator::after {
    margin-left: .25em;
}

.face-button {
    width: 100%;
    background-color: #007bff;
}

.face-img {
    margin-right: 15px;
    height: 40px;
}

.google-button {
    color: black;
    width: 100%;
    background-color: #ffffff;
}

.x-button {
    width: 100%;
    background-color: rgb(0, 0, 0);
    color: rgb(255, 255, 255);
}

.google-img,
.x-img {
    margin-left: 2px;
    margin-right: 17px;
    height: 35px;
}

.forgot-pass {
    margin-top: 10px;
    cursor: pointer;
}
</style>
<script>
import { VueTelInput } from 'vue-tel-input';
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex'

export default {
    data() {
        return {
            showInstructions: false,
            email: '',
            code: '',
            preLoading: false,
            password: '',
            repeatPassword: '',
            phone: '',
            cell: false
        }
    },
    components: {
        VueTelInput
    },
    computed: {
        ...mapState('auth', ['verified', 'waitingCode', 'codeError', 'hasPassword', 'waitingResetCode'])
    },

    async created() {
        let query = this.$route.query;

        await this.checkUserGoogle(query);
        await this.checkLoginFacebook(query)
        await this.checkLoginX(query)

        if (query.payload !== undefined) {
            var payload = query.payload;
            var valid = false;
            try {
                var decodePayload = JSON.parse(atob(payload), true);
                valid = true;
            } catch (e) {
                valid = false;
            }

            if (valid && decodePayload['email'] !== undefined) {
                this.email = (decodePayload.email);
                this.verifyEmail();
            }
        }

        if (this.$route.query.fb !== undefined && this.$route.query.fb == 'instructions') {
            this.showInstructions = true;
        }


    },
    methods: {
        ...mapActions('auth', [
            'ActionVerifyConfirmation', 'ActionConfirmation', 'ActionCreatePassword', 'ActionLogin', 'VerifyPayload',
            'ActionResetPassword', 'ActionConfirmToResetPass', 'ActionLoginGoogle', 'AuthenticateGoogle', 'ActionLoginFacebook', 'actionConfirmAcessWithFacebook', 'ActionLoginX', 'AuthenticateX'
        ]),
        redirectHome() {
            this.$router.push({ name: 'login' });
        },
        async checkLoginFacebook(query) {
            const { code, state } = query;
            if (code && window.atob(state) === 'facebook') {
                try {
                    this.preLoading = true;
                    await this.actionConfirmAcessWithFacebook({ code, state })
                    this.$router.push({ name: 'access-locations' });
                } catch (res) {
                    if (res) {
                        await this.showMessageNotFoundYou()
                    } else {
                        this.$dialog.alert({ body: 'Autenticação inválida tente novamente', title: 'Ops...' });
                    }
                    this.redirectHome()
                }
                this.preLoading = false;
            }
        },
        showMessageNotFoundYou() {
            this.$dialog.alert({ body: 'Não encontramos você por aqui', title: 'Ops...' });
        },
        async checkUserGoogle(query) {
            const { code, scope, prompt, authuser, state, error } = query
            let loginApprove = code && scope && prompt && authuser;

            if (loginApprove && window.atob(state) === 'google') {
                this.preLoading = true;
                try {
                    await this.AuthenticateGoogle({ code, scope, prompt, authuser })
                    this.$router.push({ name: 'access-locations' });
                } catch (error) {
                    await this.showMessageNotFoundYou()
                    this.$router.push({ name: 'login' });
                }
                this.preLoading = false;
            } else if (error) {
                this.$dialog.alert({ body: 'Não foi possível prosseguir, por favor permita o acesso para logar.', title: 'Acesso negado!' });
                this.$router.push({ name: 'login' });
            }
        },
        async checkLoginX(query) {
            const { code, state } = query;
            if (code && window.atob(state) === 'twitter') {
                try {
                    this.preLoading = true;
                    await this.AuthenticateX({ code, state })
                    this.$router.push({ name: 'access-locations' });
                } catch (error) {
                    await this.showMessageNotFoundYou()
                    this.$router.push({ name: 'login' });
                }
            }
            this.preLoading = false;
        },
        async verifyEmail() {
            if (!this.$v.email.$invalid) {
                try {
                    this.showInstructions = false;
                    this.preLoading = true;
                    let exist = await this.ActionVerifyConfirmation({ email: this.email });
                    if (!exist) {
                        this.showMessageNotFoundYou()
                    }
                    this.preLoading = false;

                } catch (err) {
                    console.log(err.message);
                }
            }
        },
        async confirmEmail() {
            if (!this.$v.code.$invalid) {

                try {
                    this.preLoading = true;
                    await this.ActionConfirmation({ code: this.code, email: this.email });
                    this.preLoading = false;

                } catch (err) {
                    console.log(err.message);
                }

            } else {
                console.log('codigo invalido');
            }
        },
        async createPassword() {
            if (!this.$v.password.$invalid && !this.$v.repeatPassword.$invalid) {
                try {
                    this.preLoading = true;
                    await this.ActionCreatePassword({ code: this.code, email: this.email, password: this.password });
                    this.preLoading = false;
                } catch (err) {
                    console.log(err.message);
                }
            }
        },
        async login() {
            let instance = this;
            if (!this.$v.password.$invalid && this.verified) {
                try {
                    this.preLoading = true;
                    await this.ActionLogin({ email: this.email, password: this.password });
                    this.preLoading = false;
                    this.$router.push({ name: 'access-locations' });

                } catch (res) {
                    instance.preLoading = false;
                    if (res.status == 401 || res.status == 403) {
                        instance.$dialog.alert({ body: 'Sua senha não confere', title: 'Ops...' });
                    }
                }
            }
        },
        async resetPass() {
            await this.ActionConfirmToResetPass({ code: this.code, email: this.email });
        },
        async forgotPass() {
            if (!this.$v.email.$invalid) {
                this.preLoading = true;

                try {
                    let exist = await this.ActionResetPassword({ email: this.email });

                    if (!exist) {
                        this.showMessageNotFoundYou()
                    }

                } catch (err) {
                    console.log(err.message);
                }

                this.preLoading = false;
            }
        },
        verifyEmailEnter(e) {
            if (e.keyCode === 13) {
                this.verifyEmail();
            }
        },
        enableDisable: function () {
            this.cell = !this.cell;
        },
        loginSocial(url) {
            try {
                document.location.replace(url);
            } catch (error) {
                this.errorInternal()
            }
        },
        async fblogin() {
            this.loginSocial(await this.ActionLoginFacebook());
        },
        async glogin() {
            this.loginSocial(await this.ActionLoginGoogle());
        },
        async xlogin() {
            this.loginSocial(await this.ActionLoginX());
        },

        errorInternal() {
            this.$dialog.alert({ body: 'Houve um problema interno, tente novamente mais tarde!', title: 'Ops...' });

        },
        tryAnotherTime() {
            this.$dialog.alert({ body: 'Tente novamente mais tarde!', title: 'Algo deu errado!' });
        }
    },
    validations: {
        email: { required, email },
        code: { required, minLength: minLength(4) },
        password: {
            required,
            minLength: minLength(6)
        },
        repeatPassword: {
            sameAsPassword: sameAs('password')
        }
    }
}
</script>
